import PanelPage from 'navigation/pages/PanelPage';
import { bindMethod } from 'helpers/bind';
import store from 'store';
export default class Alert extends PanelPage {
    initialized() {
        super.initialized();
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        this.refs.previousButton[method]('click', this.onPreviousButtonClick);
    }
    onPreviousButtonClick = () => {
        const page = document.querySelector('.page.product');
        page?.dispatchEvent?.(new CustomEvent('show-size'));
        store.panel.set(null);
    };
    resize() {
        super.resize();
    }
}
